import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VContainer,
    { attrs: { fluid: "", "grid-list-xl": "" } },
    [
      _c("app-monitoramento", {
        attrs: {
          acesso: _vm.acesso,
          monitoramento: "desempenho",
          titulo: "Desempenho Comportamental",
        },
        scopedSlots: _vm._u([
          {
            key: "body",
            fn: function () {
              return [
                _vm.desempenhoNaoDisponivel
                  ? _c(
                      VCol,
                      [
                        _c("app-alert", {
                          attrs: {
                            message: _vm.mensagemDesempenhoNaoDisponivel,
                            type: "info",
                          },
                        }),
                      ],
                      1
                    )
                  : _c(
                      VCol,
                      { attrs: { centered: "", cols: "12", "no-gutters": "" } },
                      [
                        _c(
                          VRow,
                          { staticClass: "justify-center ma-2" },
                          [
                            _c(
                              VTabs,
                              {
                                attrs: { centered: "", "icons-and-text": "" },
                                model: {
                                  value: _vm.categoria,
                                  callback: function ($$v) {
                                    _vm.categoria = $$v
                                  },
                                  expression: "categoria",
                                },
                              },
                              [
                                _c(VTabsSlider, {
                                  attrs: { color: "secondary" },
                                }),
                                _vm._l(_vm.categorias.length, function (i) {
                                  return _c(
                                    VTab,
                                    {
                                      key: i,
                                      staticClass: "mt-3",
                                      attrs: {
                                        href: "#" + _vm.categorias[i - 1].id,
                                      },
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticClass:
                                            "grey--text text--darken-2",
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.categorias[i - 1].descricao
                                            )
                                          ),
                                        ]
                                      ),
                                      _c(
                                        VIcon,
                                        {
                                          attrs: {
                                            color:
                                              _vm.categorias[i - 1].id ===
                                              _vm.categoria
                                                ? "secondary"
                                                : "grey",
                                          },
                                        },
                                        [
                                          _vm._v(
                                            " " +
                                              _vm._s(
                                                _vm.categorias[i - 1].icone
                                              ) +
                                              " "
                                          ),
                                        ]
                                      ),
                                    ],
                                    1
                                  )
                                }),
                              ],
                              2
                            ),
                          ],
                          1
                        ),
                        _vm.diagnostico &&
                        _vm.categoria === "DesempenhoServidor"
                          ? _c(
                              VRow,
                              { staticClass: "justify-start ml-2 mr-2" },
                              [
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "6", sm: "12" } },
                                  [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: { "max-width": "500", top: "" },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g({}, on),
                                                    [
                                                      _c(
                                                        "select-simple-unidade",
                                                        {
                                                          attrs: {
                                                            value: _vm.unidade,
                                                            "mapeamento-id":
                                                              _vm.diagnostico
                                                                .mapeamento.id,
                                                          },
                                                        }
                                                      ),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4060725823
                                        ),
                                      },
                                      [
                                        _c(
                                          "div",
                                          [
                                            _vm._v(
                                              " Selecione para carregar os dados de outra unidade. "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  color: "#9fdfeb",
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "É possível pesquisar digitando o nome ou a sigla da unidade"
                                                ),
                                              ]
                                            ),
                                            _c(
                                              VIcon,
                                              {
                                                staticClass: "mr2",
                                                attrs: {
                                                  color: "#9FDFEB",
                                                  size: "22",
                                                },
                                              },
                                              [_vm._v(" info ")]
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  VCol,
                                  { attrs: { cols: "12", md: "6", sm: "12" } },
                                  [
                                    _c(
                                      VTooltip,
                                      {
                                        attrs: {
                                          bottom: "",
                                          "max-width": "500",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "activator",
                                              fn: function ({ on }) {
                                                return [
                                                  _c(
                                                    "div",
                                                    _vm._g({}, on),
                                                    [
                                                      _c(VAutocomplete, {
                                                        attrs: {
                                                          disabled:
                                                            _vm.desempenhos
                                                              .length === 0,
                                                          items:
                                                            _vm.desempenhos,
                                                          "item-text":
                                                            "usuario.nome",
                                                          label:
                                                            "Servidores avaliados:",
                                                          placeholder:
                                                            "Digite para pesquisar...",
                                                          "prepend-icon":
                                                            "supervisor_account",
                                                          "return-object": "",
                                                        },
                                                        model: {
                                                          value: _vm.desempenho,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.desempenho = $$v
                                                          },
                                                          expression:
                                                            "desempenho",
                                                        },
                                                      }),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          573649101
                                        ),
                                      },
                                      [
                                        _c("span", [
                                          _vm._v(_vm._s(_vm.tooltipServidores)),
                                        ]),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.loaded
                          ? _c(
                              VRow,
                              { staticClass: "justify-center ma-1" },
                              [
                                _vm.visibilidade
                                  ? _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c(
                                          "keep-alive",
                                          [
                                            _c(_vm.categoria, {
                                              key: _vm.categoria,
                                              tag: "component",
                                              attrs: {
                                                desempenho: _vm.desempenho,
                                                diagnostico: _vm.diagnostico,
                                                tipo: "SERVIDORES",
                                                "menu-acesso": "MONITORAMENTO",
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    )
                                  : _vm.unidade.selecionado
                                  ? _c(
                                      VCol,
                                      { attrs: { cols: "12" } },
                                      [
                                        _c("app-alert", {
                                          attrs: {
                                            message: _vm.motivoNaoTeveAvaliacao,
                                            type: "info",
                                          },
                                        }),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ],
                              1
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
              ]
            },
            proxy: true,
          },
        ]),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }